import React from 'react'

import { InputContainer } from 'app/components/design-system-components/inputs/Input/Input'
import { IntlTelInputWrapper } from 'app/components/design-system-components/IntlTelInputWrapper'
import { CustomInputWrapper } from 'app/forms/CustomInputWrapper'
import { intTelTop10List } from 'app/shared_components/helpers'

export const mobileTelPlaceholder = '+61 412 345 678'
export const landlinePlaceholder = '02 1234 5678'

export const Tel = ({
  changeHandler,
  blurHandler,
  value,
  placeholder,
  error,
  onlyCountries = ['au'],
  international = false,
  onFocus,
  ...props
}) => {
  const containerClasses = [error && 'error', 'tel-dropdown-container']
    .filter(Boolean)
    .join(' ')

  return (
    <InputContainer {...props} className={containerClasses} as={'div'}>
      <IntlTelInputWrapper
        css={['intl-tel-input country-list', 'register-form-mobile-input']}
        defaultCountry={'au'}
        preferredCountries={intTelTop10List}
        onPhoneNumberChange={(status, value, countryData, number, id) =>
          changeHandler(number)
        }
        onPhoneNumberBlur={() => {
          blurHandler()
        }}
        onPhoneNumberFocus={onFocus}
        value={value}
        onlyCountries={international ? [] : onlyCountries}
        placeholder={placeholder}
        error={error}
        disabled={props.disabled}
      />
    </InputContainer>
  )
}

export const TelField = (props) => {
  const { name } = props
  return (
    <CustomInputWrapper
      name={name}
      customInputCmp={(customInputProps) => (
        <Tel {...customInputProps} {...props} />
      )}
    />
  )
}

export { AutocompleteTelField } from './AutocompleteTelField'
